/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

import { Configuration, PopupRequest, LogLevel } from "@azure/msal-browser";
import useLocales from "../locales/useLocales";
import useLocalesInit from "../locales/useLocalesInit";
/**
 * Configuration object to be passed to MSAL instance on creation. 
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md 
 */
export const msalConfig: Configuration = {
    auth: {
        clientId: process.env.REACT_APP_CLIENT_ID || '',
        authority: process.env.REACT_APP_AUTHORITY || '',
        knownAuthorities: [process.env.REACT_APP_KNOWN_AUTHORITIES || ''],
        redirectUri: process.env.REACT_APP_REDIRECT_URI || '',
        
    },
    cache: {
        cacheLocation: "sessionStorage", // This configures where your cache will be stored
        storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
    },
    system: {	
        loggerOptions: {	
            loggerCallback: (level, message, containsPii) => {	
                if (containsPii) {		
                    return;		
                }		
                switch (level) {		
                    case LogLevel.Error:
                        console.error(message);		
                        return;		
                    case LogLevel.Verbose:
                        console.debug(message);		
                        return;		
                    case LogLevel.Warning:
                        console.warn(message);		
                        return;
                    case LogLevel.Info:
                    default:
                        console.log(message);
                        return;
                }	
            }	
        }	
    }
};

const protectedScopes = process.env.REACT_APP_PROTECTED_SCOPES?.split(',') || [];

export const protectedResources = {
    scopes: protectedScopes
}

/**
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 * For more information about OIDC scopes, visit: 
 * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
 */
export const loginRequest: PopupRequest = {
    scopes: ["openid"],    
    extraQueryParameters: {
        ui_locales: getCurrentLanguage(),
    },
};

/**
 * Add here the scopes to request when obtaining an access token for MS Graph API. For more information, see:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/resources-and-scopes.md
 */
export const graphConfig = {
    graphMeEndpoint: process.env.REACT_APP_GRAPHME_ENDPOINT || ''
};

export function getCurrentLanguage(): string{
  
    try {
        const { currentLang } = useLocales();
        return currentLang.value;
            
    } catch (error) {
        const { currentLangValue } = useLocalesInit();   
        return currentLangValue;    
        
    }
    
}

